import { Outlet, useLocation } from "react-router-dom";
import ProfileNav from "../pages/dashboard/profileNav";
import { useTranslation } from "react-i18next";
import AgentSideBar from "../pages/dashboard/agentBoard/agentSideBar";
import { useEffect } from "react";
import { mode, primaryColor, secondaryColor } from "../utils";

const AgentDashboardLayout = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const getPageTitle = (path) => {
    const lastSegment = path.split("/").filter(Boolean).pop();
    if (!lastSegment) return "Dashboard";
    return t(lastSegment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()));
  };
  useEffect(() => {
    if (mode) {
      if (mode === "dark")
        document.documentElement.classList.add("dark", mode === "dark");
    }
    if (!primaryColor) {
      localStorage.setItem("primaryColor", "#0051ff");
    }
    if (!secondaryColor) {
      localStorage.setItem("secondaryColor", "#ff0000");
    }
  }, []);
  return (
    <div className="h-full grid grid-cols-[auto_1fr] bg-[#F9F9F9] dark:bg-[#1F2937]">
      {/* Sidebar */}
      <div className="h-auto bg-white dark:bg-gray-900">
        <AgentSideBar />
      </div>

      {/* Main Content */}
      <div className="min-h-screen px-5 py-3 text-black dark:text-white">
        <nav className="flex items-center justify-between gap-4 pb-6">
          <h1 className="text-2xl font-medium capitalize">{getPageTitle(pathname)}</h1>
          <ProfileNav />
        </nav>
        <Outlet />
      </div>
    </div>
  );
};

export default AgentDashboardLayout;
